// 视频内容数据
export type VideoItem = {
  id: string;
  slug: string;
  title: string;
  categoryId: string;
  duration: string;
  views: string;
  likes: number;
  comments: number;
  date: string;
  summary: string;
  cover: string;
  tags: string[];
  author: string;
  featured?: boolean;
};

export const videos: VideoItem[] = [
  {
    id: 'v1',
    slug: 'huaguang-red-carpet-2026',
    title: '华光奖红毯名场面：谁是你心里的最佳造型？',
    categoryId: 'stars',
    duration: '03:24',
    views: '128.6万',
    likes: 48200,
    comments: 8630,
    date: '今天 09:20',
    summary: '华光奖红毯星光熠熠，多位演员的造型搭配引发热议，一起来盘点当晚的惊艳瞬间与翻车现场。',
    cover:
      'https://readdy.ai/api/search-image?query=Star%20walking%20on%20red%20carpet%20at%20evening%20awards%20ceremony%2C%20elegant%20gown%2C%20camera%20flash%20and%20spotlights%2C%20glamorous%20celebration%2C%20editorial%20entertainment%20photography&width=640&height=360&seq=video-cover-01&orientation=landscape',
    tags: ['红毯', '造型', '华光奖'],
    author: '圈内前线',
    featured: true,
  },
  {
    id: 'v2',
    slug: 'variety-running-kings-golden-line',
    title: '综艺名场面盘点：那些笑到打鸣的综艺名场面',
    categoryId: 'variety',
    duration: '05:10',
    views: '96.2万',
    likes: 30100,
    comments: 5420,
    date: '今天 08:05',
    summary: '盘点近期热播综艺里的爆笑名场面，嘉宾互怼、整蛊反转、金句连发，承包一整天的快乐。',
    cover:
      'https://readdy.ai/api/search-image?query=Laughing%20guests%20on%20bright%20TV%20variety%20show%20set%2C%20confetti%20and%20colorful%20studio%20lights%2C%20joyful%20energy%2C%20entertainment%20TV%20photography&width=640&height=360&seq=video-cover-02&orientation=landscape',
    tags: ['综艺', '名场面', '搞笑'],
    author: '综艺收割机',
    featured: true,
  },
  {
    id: 'v3',
    slug: 'film-new-movie-behind-scenes',
    title: '新片花絮直击：一场戏拍了 47 次的幕后故事',
    categoryId: 'film',
    duration: '06:38',
    views: '74.5万',
    likes: 22800,
    comments: 3190,
    date: '昨天 21:40',
    summary: '走进新片拍摄现场，导演与演员反复打磨一场关键戏份，揭秘银幕背后的坚持与笑料。',
    cover:
      'https://readdy.ai/api/search-image?query=Movie%20set%20behind%20the%20scenes%20with%20director%20and%20actor%20reviewing%20take%2C%20film%20camera%20and%20clapperboard%2C%20cinematic%20studio%20mood%2C%20editorial%20film%20production%20photography&width=640&height=360&seq=video-cover-03&orientation=landscape',
    tags: ['影视', '花絮', '幕后'],
    author: '片场观察员',
    featured: true,
  },
  {
    id: 'v4',
    slug: 'red-food-exploration-vlog',
    title: '红人探店 Vlog：人均 30 吃到扶墙的小巷美食',
    categoryId: 'red',
    duration: '08:12',
    views: '203.1万',
    likes: 68000,
    comments: 10200,
    date: '昨天 18:30',
    summary: '头部红人带你钻进老城小巷，实测排队一小时也要吃的宝藏美食，全程真吃真反馈。',
    cover:
      'https://readdy.ai/api/search-image?query=Food%20vlogger%20tasting%20street%20food%20at%20cozy%20old%20alley%20restaurant%2C%20steaming%20delicious%20dishes%2C%20warm%20ambient%20light%2C%20lifestyle%20content%20photography&width=640&height=360&seq=video-cover-04&orientation=landscape',
    tags: ['红人', '美食', '探店'],
    author: '吃遍全城',
  },
  {
    id: 'v5',
    slug: 'stars-singer-new-album-live',
    title: '实力歌手新专辑发布，live 现场稳到不像话',
    categoryId: 'stars',
    duration: '04:45',
    views: '88.3万',
    likes: 27500,
    comments: 4210,
    date: '昨天 15:10',
    summary: '实力唱将携全新专辑回归，舞台 live 状态在线，连唱三首高难度曲目收获全场掌声。',
    cover:
      'https://readdy.ai/api/search-image?query=Singer%20performing%20live%20on%20stage%20holding%20microphone%2C%20dramatic%20concert%20lights%20and%20fog%2C%20passionate%20crowd%2C%20editorial%20concert%20photography&width=640&height=360&seq=video-cover-05&orientation=landscape',
    tags: ['歌手', '新专辑', 'live'],
    author: '乐坛速报',
  },
  {
    id: 'v6',
    slug: 'variety-quest-reality-highlight',
    title: '户外竞技综艺高光：极限挑战反转连连',
    categoryId: 'variety',
    duration: '07:26',
    views: '66.9万',
    likes: 19400,
    comments: 2780,
    date: '前天 20:15',
    summary: '户外竞技综艺上演终极对决，明星嘉宾互相套路，最终结果出人意料，全程高能。',
    cover:
      'https://readdy.ai/api/search-image?query=Outdoor%20adventure%20variety%20show%20with%20energetic%20celebrity%20cast%20running%20in%20sunny%20park%2C%20cameras%20and%20crew%2C%20fun%20competitive%20atmosphere%2C%20editorial%20photography&width=640&height=360&seq=video-cover-06&orientation=landscape',
    tags: ['户外', '竞技', '反转'],
    author: '综艺收割机',
  },
  {
    id: 'v7',
    slug: 'film-culture-drama-teaser',
    title: '古装大剧预告解析：这些隐藏细节你看懂了吗',
    categoryId: 'film',
    duration: '09:02',
    views: '112.7万',
    likes: 35600,
    comments: 6910,
    date: '前天 17:25',
    summary: '热播古装剧放出最新预告，服装道具暗藏玄机，资深剧评人逐帧拆解剧情走向与人物伏笔。',
    cover:
      'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20costume%20drama%20scene%20with%20elegant%20hanfu%20character%20and%20traditional%20palace%20architecture%2C%20moody%20cinematic%20lighting%2C%20film%20stills%20photography&width=640&height=360&seq=video-cover-07&orientation=landscape',
    tags: ['古装', '预告', '解析'],
    author: '片场观察员',
  },
  {
    id: 'v8',
    slug: 'red-daily-life-vlog-morning',
    title: '晨间自律 Vlog：红人的一天从六点开始',
    categoryId: 'red',
    duration: '06:55',
    views: '59.4万',
    likes: 15800,
    comments: 2030,
    date: '前天 09:00',
    summary: '跟随头部红人记录清晨六点的自律日常，运动、早餐、工作安排，治愈又上头。',
    cover:
      'https://readdy.ai/api/search-image?query=Calm%20morning%20routine%20vlog%20scene%20with%20young%20woman%20doing%20yoga%20by%20window%2C%20soft%20sunrise%20light%2C%20minimal%20cozy%20room%2C%20lifestyle%20photography&width=640&height=360&seq=video-cover-08&orientation=landscape',
    tags: ['红人', 'Vlog', '自律'],
    author: '慢生活记录',
  },
  {
    id: 'v9',
    slug: 'stars-backstage-interview-fun',
    title: '后台采访翻车名场面：明星被问懵的名场面合集',
    categoryId: 'stars',
    duration: '05:48',
    views: '145.3万',
    likes: 51000,
    comments: 8300,
    date: '3 天前 21:00',
    summary: '整理近期各大颁奖礼与发布会后台采访的搞笑瞬间，主持人连环提问，明星机智接招。',
    cover:
      'https://readdy.ai/api/search-image?query=Celebrity%20backstage%20interview%20with%20microphones%20and%20bright%20press%20lights%2C%20playful%20laughing%20atmosphere%2C%20entertainment%20press%20photography&width=640&height=360&seq=video-cover-09&orientation=landscape',
    tags: ['采访', '后台', '名场面'],
    author: '圈内前线',
  },
  {
    id: 'v10',
    slug: 'variety-cooking-show-challenge',
    title: '明星做饭挑战：一锅黑暗料理引发的混战',
    categoryId: 'variety',
    duration: '06:17',
    views: '84.8万',
    likes: 26900,
    comments: 4780,
    date: '3 天前 16:40',
    summary: '美食综艺明星下厨挑战，从切菜到出锅全程高能，评委表情管理彻底失败。',
    cover:
      'https://readdy.ai/api/search-image?query=Celebrities%20cooking%20in%20bright%20kitchen%20studio%20for%20food%20variety%20show%2C%20fun%20chaotic%20cooking%20scene%2C%20warm%20lighting%2C%20entertainment%20photography&width=640&height=360&seq=video-cover-10&orientation=landscape',
    tags: ['综艺', '美食', '挑战'],
    author: '综艺收割机',
  },
  {
    id: 'v11',
    slug: 'film-youth-movie-teaser-analysis',
    title: '青春片花絮：那些让全场泪崩的拍摄瞬间',
    categoryId: 'film',
    duration: '07:33',
    views: '71.2万',
    likes: 21100,
    comments: 3020,
    date: '4 天前 19:05',
    summary: '青春电影拍摄现场情绪拉满，主创分享戏外故事，一场毕业戏让整个片场泪目。',
    cover:
      'https://readdy.ai/api/search-image?query=Emotional%20youth%20movie%20behind%20the%20scenes%20with%20young%20actors%20on%20sunny%20school%20campus%2C%20warm%20afternoon%20light%2C%20cinematic%20film%20production%20photography&width=640&height=360&seq=video-cover-11&orientation=landscape',
    tags: ['青春', '花絮', '泪目'],
    author: '片场观察员',
  },
  {
    id: 'v12',
    slug: 'red-3d-artist-creative-short',
    title: '创意短片爆红：红人用 3D 技术还原童年记忆',
    categoryId: 'red',
    duration: '04:28',
    views: '172.6万',
    likes: 58900,
    comments: 9110,
    date: '4 天前 12:00',
    summary: '创意红人用 3D 建模还原 90 后童年场景，细节满满引发集体回忆，评论区泪目一片。',
    cover:
      'https://readdy.ai/api/search-image?query=Creative%203D%20animation%20studio%20desk%20with%20monitor%20showing%20colorful%20retro%20scene%2C%20young%20artist%20working%2C%20cozy%20creative%20workspace%2C%20lifestyle%20photography&width=640&height=360&seq=video-cover-12&orientation=landscape',
    tags: ['红人', '3D', '创意'],
    author: '创意星球',
  },
  {
    id: 'v13',
    slug: 'stars-dating-rumor-clarify',
    title: '明星绯闻辟谣：工作室深夜发声还原真相',
    categoryId: 'stars',
    duration: '02:58',
    views: '99.1万',
    likes: 23400,
    comments: 6870,
    date: '今天 11:00',
    summary: '面对网络热议，当事人工作室深夜发布声明还原时间线，真相究竟是什么？',
    cover:
      'https://readdy.ai/api/search-image?query=Press%20conference%20scene%20with%20spotlights%20and%20reporter%20microphones%2C%20dramatic%20moody%20lighting%2C%20entertainment%20news%20photography&width=640&height=360&seq=video-cover-13&orientation=landscape',
    tags: ['明星', '辟谣', '热点'],
    author: '圈内前线',
  },
  {
    id: 'v14',
    slug: 'stars-childhood-movie-role',
    title: '童星长大后反差有多大？这些角色你认出来了吗',
    categoryId: 'stars',
    duration: '05:02',
    views: '134.7万',
    likes: 41200,
    comments: 5340,
    date: '2 天前 10:30',
    summary: '盘点那些年我们追过的童星，如今有的转型幕后，有的成为流量担当。',
    cover:
      'https://readdy.ai/api/search-image?query=Side%20by%20side%20childhood%20and%20grown%20up%20portrait%20collage%20of%20young%20actor%2C%20nostalgic%20warm%20tones%2C%20editorial%20photo%20collage&width=640&height=360&seq=video-cover-14&orientation=landscape',
    tags: ['童星', '对比', '成长'],
    author: '乐坛速报',
  },
  {
    id: 'v15',
    slug: 'variety-singing-show-golden',
    title: '音乐综艺神仙打架：这嗓子是真实存在的吗',
    categoryId: 'variety',
    duration: '07:49',
    views: '156.2万',
    likes: 47300,
    comments: 8290,
    date: '2 天前 21:20',
    summary: '实力歌手同台竞演，高音一个比一个稳，现场观众表示耳朵怀孕了。',
    cover:
      'https://readdy.ai/api/search-image?query=Singer%20performing%20powerful%20vocal%20on%20music%20competition%20stage%2C%20blue%20and%20gold%20stage%20lights%2C%20passionate%20audience%2C%20concert%20photography&width=640&height=360&seq=video-cover-15&orientation=landscape',
    tags: ['音乐', '竞演', '高音'],
    author: '综艺收割机',
  },
  {
    id: 'v16',
    slug: 'variety-behind-bts-fun',
    title: '综艺片场花絮：镜头外的他们到底有多皮',
    categoryId: 'variety',
    duration: '04:41',
    views: '78.3万',
    likes: 22700,
    comments: 3180,
    date: '3 天前 14:50',
    summary: '正片之外的片场日常曝光，明星们私下互怼整蛊，笑料不断。',
    cover:
      'https://readdy.ai/api/search-image?query=Fun%20behind%20the%20scenes%20on%20variety%20show%20set%20with%20celebrities%20laughing%20and%20cameras%2C%20bright%20colorful%20studio%2C%20candid%20photography&width=640&height=360&seq=video-cover-16&orientation=landscape',
    tags: ['片场', '花絮', '搞笑'],
    author: '综艺收割机',
  },
  {
    id: 'v17',
    slug: 'film-award-sweep-recap',
    title: '年度大剧横扫颁奖礼：实至名归还是众望所归',
    categoryId: 'film',
    duration: '06:23',
    views: '120.5万',
    likes: 33900,
    comments: 4750,
    date: '3 天前 18:10',
    summary: '年度热门剧集在各大颁奖礼上收获颇丰，主创团队分享幕后创作心得。',
    cover:
      'https://readdy.ai/api/search-image?query=Elegant%20award%20trophy%20on%20stage%20with%20gold%20confetti%20and%20warm%20spotlight%2C%20celebration%20atmosphere%2C%20cinematic%20photography&width=640&height=360&seq=video-cover-17&orientation=landscape',
    tags: ['影视', '颁奖', '大剧'],
    author: '片场观察员',
  },
  {
    id: 'v18',
    slug: 'film-tv-new-season-teaser',
    title: '续作回归首曝预告：老粉狂喜，新粉入坑',
    categoryId: 'film',
    duration: '03:36',
    views: '92.8万',
    likes: 28500,
    comments: 3960,
    date: '4 天前 22:00',
    summary: '热门剧集续作发布首支预告，熟悉的配方与全新的剧情走向同时引爆期待。',
    cover:
      'https://readdy.ai/api/search-image?query=Dramatic%20movie%20poster%20teaser%20with%20silhouette%20against%20moody%20cloudy%20sky%2C%20epic%20cinematic%20tone%2C%20film%20marketing%20photography&width=640&height=360&seq=video-cover-18&orientation=landscape',
    tags: ['续作', '预告', '回归'],
    author: '片场观察员',
  },
  {
    id: 'v19',
    slug: 'red-makeup-tutorial-viral',
    title: '爆款妆容教程：五分钟学会全网都在化的妆',
    categoryId: 'red',
    duration: '05:31',
    views: '188.4万',
    likes: 62000,
    comments: 8900,
    date: '3 天前 13:20',
    summary: '红人手把手教你复刻近期爆火妆容，化妆新手也能轻松上手。',
    cover:
      'https://readdy.ai/api/search-image?query=Makeup%20tutorial%20scene%20with%20cosmetics%20brush%20and%20palette%20on%20bright%20vanity%20desk%2C%20feminine%20warm%20light%2C%20beauty%20content%20photography&width=640&height=360&seq=video-cover-19&orientation=landscape',
    tags: ['红人', '美妆', '教程'],
    author: '慢生活记录',
  },
  {
    id: 'v20',
    slug: 'red-pet-life-vlog',
    title: '萌宠治愈 Vlog：被猫主子支配的一天',
    categoryId: 'red',
    duration: '03:52',
    views: '67.6万',
    likes: 19800,
    comments: 2210,
    date: '4 天前 16:45',
    summary: '记录养宠人平凡又治愈的一天，毛孩子的一举一动都让人忍不住姨母笑。',
    cover:
      'https://readdy.ai/api/search-image?query=Adorable%20cat%20playing%20in%20sunny%20cozy%20living%20room%2C%20soft%20warm%20light%2C%20cuteness%20overload%2C%20pet%20lifestyle%20photography&width=640&height=360&seq=video-cover-20&orientation=landscape',
    tags: ['红人', '萌宠', '治愈'],
    author: '慢生活记录',
  },
];